import { useState, useEffect } from 'react'
import { InteractorStoreWarehouse } from '../../Main'

const InteractorStoreWarehouseView = () => {
  const { listWarehouseByStore } = InteractorStoreWarehouse()
  const [optionWarehouse, setOptionWarehouse] = useState([])
  const [defaultValue, setDefaultValue] = useState([])
  const [loadingWarehouse, setLoadingWarehouse] = useState(false)

  useEffect(() => {
    listWarehouseByStore(setOptionWarehouse, setDefaultValue, setLoadingWarehouse)
  }, [listWarehouseByStore])

  return {
    optionWarehouse,
    defaultValue,
    loadingWarehouse,
  }
}

export default InteractorStoreWarehouseView
